import type { ReactNode } from "react";
import { Button } from "@base-ui/react/button";
// @ts-expect-error pure js
import { FolderArrowDown, Visualiser } from "./Icons";
import style from "./FileDownloadLink.module.css";
import ButtonAction from "./ButtonAction";
// @ts-expect-error pure js
import { DocType } from "../../utils/constants/documents";
// @ts-expect-error pure js
import { SignatureContratStatus } from "../../models/signatureElectronique";
import useDocumentDownload, {
  type DownloadableFile,
} from "../../hooks/use-document-download";

interface DocumentDownloadLinkProps {
  documentId?: number;
  downloadUrl?: string;
  mimetype?: string;
  doctype?: string;
  file?: DownloadableFile;
  isSigned?: boolean;
  save?: boolean;
  children?: ReactNode;
  className?: string;
}

export default function DocumentDownloadLink({
  documentId,
  downloadUrl,
  mimetype,
  doctype = DocType.GENERIC_FILE,
  file,
  isSigned = file?.signature_electronique_status ===
    SignatureContratStatus.Archived.status,
  save,
  children,
  className,
}: DocumentDownloadLinkProps) {
  const { downloadHandler, overlay, isReady } = useDocumentDownload({
    documentId,
    downloadUrl,
    mimetype,
    doctype,
    file,
    isSigned,
    save,
  });

  const linkIcon = save ? <FolderArrowDown stroke="#0C69F5" /> : <Visualiser />;

  const display = (
    <>
      {children && (
        <Button
          render={<div>{children}</div>}
          nativeButton={false}
          className={style.button}
          onClick={downloadHandler}
        />
      )}
      {!children && <ButtonAction onClick={downloadHandler} logo={linkIcon} />}
    </>
  );

  return (
    <div className={className}>
      {overlay}
      {isReady && display}
    </div>
  );
}
